/**
 * Default visible data columns per Admin list screen (Actions always appended).
 * Table shows these 4 + Actions = 5 columns until the user customizes.
 */
export const TABLE_COLUMN_DEFAULTS = {
  deals: ["dealId", "entName", "orgName", "status"],
  enquiry: ["busName", "dealCategoryName", "contactName", "status"],
  business: ["busName", "dealCategoryName", "businessTypeName", "status"],
  investor: ["investorName", "investorTypeName", "email", "status"],
  enterprise: ["entName", "pocName", "email", "status"],
  creditLimit: ["orgName", "entName", "requestedCredit", "status"],
  creditLimitRequests: ["orgName", "enterpriseName", "requestedCredit", "status"],
  settlements: ["utr", "orgName", "amount"],
  payments: ["appTransactionId", "txnId", "transactionId", "createdAt", "transactionType", "purpose", "beneficiaryAccNum", "beneficiaryAccNumber", "amount", "statusName",],
  wallets: ["orgName", "vaAccountId", "balance"],
  manageUsers: ["userName", "email", "roleName"],
  manageRoles: ["roleId", "roleName", "Privilege"],
  manageRm: ["userName", "rmCityName", "usersAssigned"],
  managePermissions: ["privilegeId", "privilegeName", "privilegeCode"],
  jvDeals: ["dealId", "orgName", "dealName", "dealStatus", "dealValue"],
};

export const buildTableScreenKey = (screen, suffix = "") =>
  `admin.${screen}${suffix ? `.${suffix}` : ""}.v3`;
